import { memo, VFC, useEffect, useState } from 'react';
import {
  Center,Heading,Box,Flex,Divider,Text,
} from '@chakra-ui/react';
import { useNavigate  } from "react-router-dom";
import { CurrentTable } from '../molecules/CurrentTable';

// import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";

export const CurrentView: VFC = memo(() => {
  // const { loginUser } = useLoginUser();
  const [ title ] = useState('最新状況');
  const [ dtStr, setDTStr ] = useState("");
  const navigate = useNavigate();
  
  // 15分で自動リロード
  useEffect(() => {
    const intervalId = setInterval(() => {
      navigate('/reloadURL?url=/currentView');
    }, 60000 * 15);
    return () => {
      clearInterval(intervalId);
    };
  }, [navigate]);

  return (
    <Center> 
      <Box
        w="100%"
        bg="white"
        shadow="md"
        marginTop="10px"
        marginRight="10px"
        borderRadius="10px"
      >
        <Flex>
          <Heading size="md" margin="10px">
            <Flex>{`■${title}`}<Text color="green">{dtStr}</Text></Flex>
          </Heading> 
        </Flex>
        <Divider orientation="horizontal" mt="10px" mb="10px" />
        <Box margin="10px">
          <CurrentTable setDTStr={setDTStr} />
        </Box>  
      </Box>
    </Center>
  );
});